import { type RowField } from '../../../types/graphql.form.ts'

export default function Input({
	className,
	visibility,
	displayName,
	labelPosition,
	error,
	handle,
	uid,
	required,
	placeholder,
	defaultValue,
	type = 'text',
	maxLength,
	minLength,
	max,
	min,
}: {
	className: string
	error: string | false | null
} & Pick<
	RowField,
	| 'name'
	| 'visibility'
	| 'labelPosition'
	| 'displayName'
	| 'handle'
	| 'uid'
	| 'placeholder'
	| 'required'
	| 'defaultValue'
> &
	React.DetailedHTMLProps<
		React.InputHTMLAttributes<HTMLInputElement>,
		HTMLInputElement
	>) {
	return (
		<div
			className={`${className} flex flex-col ${
				visibility === 'hidden' ? 'hidden' : ''
			}`}
		>
			{labelPosition === 'verbb\\formie\\positions\\AboveInput' && (
				<label htmlFor={handle}>{displayName}</label>
			)}
			{labelPosition === 'verbb\\formie\\positions\\LeftInput' && (
				<label htmlFor={handle}>{displayName}</label>
			)}
			{error && <span className="error-message">{error}</span>}
			<input
				name={handle}
				id={uid}
				className={`${error ? 'error' : ''} ${className}`}
				type={type}
				min={min}
				max={max}
				minLength={minLength}
				maxLength={maxLength}
				required={required}
				placeholder={placeholder}
				defaultValue={defaultValue || undefined}
				disabled={visibility === 'disabled'}
			/>
			{labelPosition === 'verbb\\formie\\positions\\BelowInput' && (
				<label htmlFor={handle}>{displayName}</label>
			)}
			{labelPosition === 'verbb\\formie\\positions\\RightInput' && (
				<label htmlFor={handle}>{displayName}</label>
			)}
		</div>
	)
}
